import styled from "styled-components";
import {BrgButton, Colors, FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {RectangularButtonFilled} from "../../components/buttons";

export const TeamSubscribeSuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    width: 700px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
    }
`

export const TeamSubscribeSuccessInfo = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 700px;
    align-items: center;
    padding: 32px 40px 40px 40px;
    gap: 32px;
    border-radius: 8px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        border-radius: 8px 8px 0 0;
    }
`

export const TeamSubscribeSuccessTitle = styled.div`
    font-family: Inter;
    color: #151514;
    font-size: 30px;
    line-height: 40px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.6px;
    padding-right: 80px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        font-style: normal;
        font-weight: 600;
        line-height: 29px; /* 126.087% */
        letter-spacing: -0.46px;
        padding-right: 0px;
    }
`

export const TeamSubscribeBottomWrapper = styled(FlexBox)`

    gap: 24px;
    width: 100%;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        gap: 40px;
    }
`

export const TeamSubscribeSuccessDesc = styled.div`
    color: #909090;
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: 129.412%;
    letter-spacing: -0.34px;
`

export const TeamSubscribeContinueButton = styled(BrgButton)`
    width: 207px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`
export const SubscribeContinueButton = styled(RectangularButtonFilled)`
    display: flex;
    height: 48px!important;
    width: 270px;
    padding: 12px 48px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #151514;
    cursor: pointer;
    color: #FFF;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 29.412%;
    letter-spacing: -0.34px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        height: 46px!important;
    }
`

export const TeamSubscribeCloseIconWrapper = styled.div`
    // position: absolute;
    // top: 37px;
    // right: 45px;
    cursor: pointer;
`

export const TeamSubscribeRow = styled.div`
    display: flex;
    gap: 24px;
`

export const TeamSubscribeEmailInput = styled.input`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 48px;
  width: 100%;
    border: none;
    outline: none;

    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack100};
    
    &::placeholder {
        color: ${Colors.galBlack31};
    }
`import styled from "styled-components";
import {BrgButton, Colors, FlexBox} from "@brg/ui";
import {LayoutConst} from "../../../core";
import {RectangularButtonFilled} from "../../components/buttons";

export const TeamSubscribeSuccessWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    width: 700px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
    }
`

export const TeamSubscribeSuccessInfo = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 700px;
    align-items: center;
    padding: 32px 40px 40px 40px;
    gap: 32px;
    border-radius: 8px;
    background: #FEFEFE;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.12);

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        border-radius: 8px 8px 0 0;
    }
`

export const TeamSubscribeSuccessTitle = styled.div`
    font-family: Inter;
    color: #151514;
    font-size: 30px;
    line-height: 40px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: -0.6px;
    padding-right: 80px;

    @media (max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        font-style: normal;
        font-weight: 600;
        line-height: 29px; /* 126.087% */
        letter-spacing: -0.46px;
        padding-right: 0px;
    }
`

export const TeamSubscribeBottomWrapper = styled(FlexBox)`

    gap: 24px;
    width: 100%;
    
    @media (max-width: ${LayoutConst.screen.s}px) {
        flex-direction: column;
        gap: 40px;
    }
`

export const TeamSubscribeSuccessDesc = styled.div`
    color: #909090;
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 500;
    line-height: 129.412%;
    letter-spacing: -0.34px;
`

export const TeamSubscribeContinueButton = styled(BrgButton)`
    width: 207px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
    }
`
export const SubscribeContinueButton = styled(RectangularButtonFilled)`
    display: flex;
    height: 48px!important;
    width: 270px;
    padding: 12px 48px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #151514;
    cursor: pointer;
    color: #FFF;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: 29.412%;
    letter-spacing: -0.34px;

    @media (max-width: ${LayoutConst.screen.s}px) {
        width: 100%;
        height: 46px!important;
    }
`

export const TeamSubscribeCloseIconWrapper = styled.div`
    // position: absolute;
    // top: 37px;
    // right: 45px;
    cursor: pointer;
`

export const TeamSubscribeRow = styled.div`
    display: flex;
    gap: 24px;
`

export const TeamSubscribeEmailInput = styled.input`
  display: flex;
  align-items: center;
  padding: 15px 16px 13px;
  background: #F2F2F2;
  border-radius: 3px;
  height: 48px;
  width: 100%;
    border: none;
    outline: none;

    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: ${Colors.galBlack100};
    
    &::placeholder {
        color: ${Colors.galBlack31};
    }
`